/** Amounts travel from the API in haléře and are never floats on the way. */
export function formatPrice(amountMinor: number): string {
  return `${(amountMinor / 100).toLocaleString("cs-CZ")} Kč`;
}
